import {
  SCAN_EFFORT_ITERATIONS,
  SCAN_EFFORT_LEVELS,
  type ScanEffortLevel,
} from '@terra/shared-contracts-applications';
import { useTranslations } from 'next-intl';
import type { ScanEffortSliderOption } from './ScanEffortSlider';

export const useScanEffortLevelOptions =
  (): ScanEffortSliderOption<ScanEffortLevel>[] => {
    const t = useTranslations('designSystem.scanEffort');

    return SCAN_EFFORT_LEVELS.map((level) => ({
      value: level,
      label: t(`levels.${level}`),
      description: t(`levelDescriptions.${level}`, {
        iterations: SCAN_EFFORT_ITERATIONS[level],
      }),
    }));
  };
